import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';


const firebaseConfig = {
    apiKey: "AIzaSyDq0Fx6u98FwJdb0XkvlPj_cxIr5txJcpI",
    authDomain: "netflix-clone-2b7b9.firebaseapp.com",
    projectId: "netflix-clone-2b7b9",
    storageBucket: "netflix-clone-2b7b9.appspot.com",
    messagingSenderId: "504145476914",
    appId: "1:504145476914:web:5235865efc5916e5672b2b"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth()

  export { auth };
  export default db;